import {VscTools} from 'react-icons/vsc';

const ToolsIcon = () => {
    return (
        <VscTools size={22}/>
    )
};

export default ToolsIcon;